import React, { useEffect, useRef } from 'react';
import { useGallery } from 'core/hooks/useGallery';
import 'assets/css/gallery.css';
import GalleryFilter from './GalleryFilter';
import GalleryModal from '../modal/GalleryModal';
import ImageWithBaseApi from '../../common/mediaRender/ImageWithBaseApi';

const getYouTubeThumbnail = (videoUrl) => {
    const videoId = videoUrl.includes('youtube.com') ? videoUrl.split('v=')[1] : null;
    return videoId ? `https://img.youtube.com/vi/${videoId}/0.jpg` : null;
};

const PropertyGallery = ({ publicUrl, mediaItems = [], title = "FOTOS DEL PROYECTO" }) => {
    const {
        showModal,
        setShowModal,
        currentIndex,
        setCurrentIndex,
        filter,
        setFilter,
        filteredItems,
        handlePrevious,
        handleNext
    } = useGallery(mediaItems);

    const galleryRef = useRef(null);
    const isMobile = window.innerWidth <= 768;

    const hasVideos = mediaItems.some(item => item.type === 'video');

    useEffect(() => {
        if (galleryRef.current) {
            galleryRef.current.scrollTop = 0;
        }
    }, [filter]);

    return (
        <div className="property-gallery-container w-100">

            {title && <h4 className="title-2">{title}</h4>}
            {/* <GalleryFilter filter={filter} setFilter={setFilter} hasVideos={hasVideos} /> */}
            <div
                className="gallery-grid scroll-light mt-3"
                style={{ maxHeight: isMobile ? '420px' : '435px', overflowX: 'hidden', padding: '0px', paddingRight: '15px' }}
                ref={galleryRef}
            >
                {filteredItems.map((item, index) => (
                    <div
                        key={index}
                        className="gallery-item"
                        onClick={() => {
                            setCurrentIndex(index);
                            setShowModal(true);
                        }}
                    >
                        {item.type === 'video' ? (
                            <ImageWithBaseApi
                                src={getYouTubeThumbnail(item.src) || item.thumbnail}
                                alt=""
                                loadingIconFontSize="60px"
                                ladingClass="loading-class"
                            />
                        ) : (
                            <ImageWithBaseApi
                                src={item.src}
                                alt=""
                                loadingIconFontSize="60px"
                                ladingClass="loading-class"
                            />
                        )}
                        {item.type === 'video' && (
                            <div className="video-indicator">
                                <span>▶</span>
                            </div>
                        )}
                    </div>
                ))}
            </div>
            {showModal && (
                <GalleryModal
                    currentItem={filteredItems[currentIndex]}
                    handlePrevious={handlePrevious}
                    handleNext={handleNext}
                    setShowModal={setShowModal}
                    publicUrl={publicUrl}
                />
            )}
        </div>
    );
};

export default PropertyGallery;